module.exports = __webpack_public_path__ + "img/Mardona-8.452b42f7.webp";